import z from 'zod'
import { nullSafeOptionalFirestoreTimestamp } from '../shared/schema'

export const schema = z.object({
  userId: z.string(),
  slideDeckId: z.string(),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    userId: '',
    slideDeckId: '',
    createdAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreUserProfileSlideDeckReview extends z.infer<
  typeof schema
> {}
